<template>
  <div class="programManagement" style="margin: -15px -15px">
    <a-spin :indicator="indicator" :spinning="spinning">
      <div class="search_Info">
        <div>
          名称: &nbsp;<a-input
            v-model="searchName"
            placeholder="输入名称搜索"
            style="width: 180px"
            size="default"
            @keyup.enter="searchEnter"
          />&nbsp;&nbsp;&nbsp;
          <a-button style="margin-left: 10px" type="primary" @click="searchOk"
            >查询</a-button
          >
          <a-button style="margin-left: 10px" @click="searchReset"
            >重置</a-button
          >
        </div>
      </div>
      <div class="table_Info">
        <a-button type="primary" @click="() => (this.addShow = true)"
          >新增</a-button
        >
        <a-table
          :columns="columns"
          style="min-height: 500px"
          :data-source="InfoTable"
          :rowKey="(record) => record.id"
          :pagination="false"
        >
          <span slot="operate" slot-scope="text, item, index">
            <a
              style="margin-right: 10px"
              v-if="index !== 0"
              @click="moveUp(item.id)"
              >上移</a
            >
            <a
              style="margin-right: 10px"
              v-if="index !== InfoTable.length - 1"
              @click="moveDown(item.id)"
              >下移</a
            >
            <a @click="editBtn(item.id)" style="margin-right: 10px">修改</a>
            <a-popconfirm
              title="确定删除?"
              ok-text="是"
              cancel-text="否"
              @confirm="delBtn(item.id)"
              @cancel="cancel"
            >
              <a style="margin-right: 10px">删除</a>
            </a-popconfirm>
          </span>
          <span slot='isShow' slot-scope="text, item, index">
            <a-switch
              :checked="item.isShow!==0"
              unchecked-value="END"
              checked-children="是"
              un-checked-children="否"
              @change="switchIsShow(item.id,item.isShow === 1?0:1,item)"
            />
          </span>
           <span slot='isShowMina' slot-scope="text, item, index">
            <a-switch
              :checked="item.isShowMina!==0"
              unchecked-value="END"
              checked-children="是"
              un-checked-children="否"
              @change="switchIsShowMina(item.id,item.isShowMina === 1?0:1,item)"
            />
          </span>
             <span slot='isShowNavigation' slot-scope="text, item, index">
               <a-switch
                :checked="item.isShowNavigation!==0"
              unchecked-value="END"
              checked-children="是"
              un-checked-children="否"
              @change="switchIsShowNavigation(item.id,item.isShowNavigation === 1?0:1,item)"
            />
          </span>
        </a-table>
        <!--      <div  style="display: flex;justify-content: flex-end;right: 35px;margin-top: 15px;">-->
        <!--        <a-pagination v-model="pagination.current"-->
        <!--                      :total="pagination.total"-->
        <!--                      @change="tableChange" />-->
        <!--      </div>-->
      </div>

      <a-modal v-model="addShow"
               title="新增"
               @ok="addOk"
               @cancel="addCancel" :width="800">
        <a-form-model
          :model="addForm"
          :label-col="labelCol"
          :rules="rules"
          :wrapper-col="wrapperCol"
          ref="add"
        >
          <a-form-model-item prop="title" label="栏目标题">
            <a-input v-model="addForm.title" />
          </a-form-model-item>

          <a-form-model-item prop="code" label="栏目标识">
            <a-input v-model="addForm.code" />
          </a-form-model-item>

           <a-form-model-item label="是否展示在小程序首页">
            <a-radio-group v-model="addForm.isShowMina">
              <a-radio value="1">是</a-radio>
              <a-radio value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="是否展示在app首页">
            <a-radio-group v-model="addForm.isShow">
              <a-radio value="1">是</a-radio>
              <a-radio value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="是否展示在导航栏">
            <a-radio-group v-model="addForm.isShowNavigation">
              <a-radio value="1">是</a-radio>
              <a-radio value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="展示图片">
            <div style="display: flex">
              <div class="uploadImg">
                <input
                  style="
                    cursor: pointer;
                    width: 100px;
                    height: 100px;
                    opacity: 0;
                  "
                  accept="image/*"
                  type="file"
                  id="addIcon"
                  @change="upload"
                  ref="addIcon"
                />
              </div>
              <div style="margin-left: 10px" class="upload1">
                <img
                  v-if="addForm.showImg"
                  alt=""
                  style="width: 320px; height: 86px"
                  :src="addForm.showImg"
                />
              </div>
            </div>
            <div>
              <span style="font-size: 14px"
                >注：建议尺寸1920*520，宽度不能超过1920</span
              >
            </div>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <a-modal v-model="editShow" title="修改" @ok="editOk" @cancel="editCancel" :width="800">
        <a-form-model
          :model="editForm"
          :label-col="labelCol"
          :rules="rules"
          :wrapper-col="wrapperCol"
          ref="edit"
        >
          <a-form-model-item prop="title" label="栏目标题">
            <a-input v-model="editForm.title" />
          </a-form-model-item>

          <a-form-model-item prop="code" label="栏目标识">
            <a-input v-model="editForm.code" />
          </a-form-model-item>
           <a-form-model-item label="是否展示在小程序首页">
            <a-radio-group v-model="editForm.isShowMina">
              <a-radio value="1">是</a-radio>
              <a-radio value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="是否展示在app首页">
            <a-radio-group v-model="editForm.isShow">
              <a-radio value="1">是</a-radio>
              <a-radio value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="是否展示在导航栏">
            <a-radio-group v-model="editForm.isShowNavigation">
              <a-radio value="1">是</a-radio>
              <a-radio value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="展示图片">
            <div style="display: flex">
              <div class="uploadImg">
                <input
                  style="
                    cursor: pointer;
                    width: 100px;
                    height: 100px;
                    opacity: 0;
                  "
                  accept="image/*"
                  type="file"
                  id="addIcon"
                  @change="uploadEdit"
                  ref="addIcon"
                />
              </div>
              <div style="margin-left: 10px" class="upload1">
                <img
                  v-if="editForm.showImg"
                  alt=""
                  style="width: 320px; height: 86px"
                  :src="editForm.showImg"
                />
              </div>
            </div>
            <div>
              <span style="font-size: 14px"
                >注：建议尺寸1920*520，宽度不能超过1920</span
              >
            </div>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-spin>
  </div>
</template>

<script>
import { update_New } from "../../../utils/update";
import {
  delProgram,
  getProgram,
  getProgramId,
  postProgram,
  postProgramDown,
  postProgramUp,
  putProgram,
} from "@/service/dataDictionary_api";

export default {
  name: "programManagement",
  data() {
    return {
      spinning: false,
      indicator: <a-icon type="loading" style="font-size: 24px" spin />,
      searchName: "",
      addShow: false,
      editShow: false,
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          customRender: (text, record, index) => `${index + 1}`,
          align: "center",
          width: "8%",
        },
        {
          title: "名称",
          dataIndex: "title",
        },
        {
          title: "栏目标识",
          dataIndex: "code",
        },
            {
          title: "是否展示在小程序首页",
          dataIndex: "isShowMina",
          scopedSlots: { customRender: "isShowMina" },
        },
        {
          title: "是否展示在app首页",
          dataIndex: "isShow",
          scopedSlots: { customRender: "isShow" },
        },
         {
          title: "是否展示在导航栏",
          dataIndex: "isShowNavigation",
           scopedSlots: { customRender: "isShowNavigation" },
        },
        {
          title: "操作",
          width: "20%",
          scopedSlots: { customRender: "operate" },
        },
      ],
      InfoTable: [],
      editForm: {},
      addForm: {},
      rules: {
        title: [{ required: true, message: "请输入栏目标题", trigger: "blur" }],
        code: [{ required: true, message: "请输入栏目标识", trigger: "blur" }],
      },
      labelCol: { span: 7 },
      wrapperCol: { span: 15 },

      platform:'yunicu',
    };
  },
  created() {
    this.$store.dispatch("setManageHeaderTitle", "栏目管理");
  },
  mounted() {
    this.platform = this.$route.query.platform;
    this.getProgramList();
  },
  watch:{
    $route(to,from,path){
      // console.log(to.query.platform)
      this.platform = to.query.platform;
      this.getProgramList();
    }
  },
  methods: {
    //获取栏目列表
    async getProgramList(pageNum, title) {
      this.spinning = true;
      let data = {
        pageNum, title,
        pageSize:999,
        platform:this.platform
      }
      const Info = await getProgram(data);
      if (Info.code === 0) {
        this.InfoTable = Info.data.wyYs;
        this.pagination.total = Info.data.count;
      } else {
        this.$message.warn("连接失败,请联系管理员" + Info.message);
      }
      this.spinning = false;
    },
    //分页跳转
    tableChange(e) {
      this.getProgramList(e);
    },
    searchEnter() {
      this.searchOk();
    },
    //确认搜索
    searchOk() {
      this.getProgramList(1, this.searchName);
      this.pagination.current = 1;
    },
    //搜索重置
    searchReset() {
      this.getProgramList();
      this.pagination.current = 1;
      this.searchName = "";
    },
    moveUp(id) {
      postProgramUp(id);
      this.timer = setTimeout(() => {
        this.getProgramList(this.pagination.current);
      }, 1000);
    },
    moveDown(id) {
      postProgramDown(id);
      this.timer = setTimeout(() => {
        this.getProgramList(this.pagination.current);
      }, 1000);
    },
    addCancel(){
      this.$refs.add.resetFields();
      this.addForm = {};
    },
    //新增
    async addOk() {
      this.$refs.add.validate(async (valid) => {
        if (valid) {
          const data = {
            title: this.addForm.title,
            code: this.addForm.code,
            isShow: this.addForm.isShow,
            showImg: this.addForm.showImg,
            isShowNavigation:this.addForm.isShowNavigation,
            isShowMina:this.addForm.isShowMina,
            platform:this.platform
          };
          const add = await postProgram(data);
          if (add.code === 0) {
            //刷新列表
            await this.getProgramList(this.pagination.current);
            this.$message.success("添加成功");
            //清空输入框
            this.addCancel();
            //关闭对话框
            this.addShow = false;
          }
        } else {
          this.$message.error("输入有空~");
          return false;
        }
      });
    },
    async editBtn(id) {
      const Info = await getProgramId(id);
      this.editForm = Info.data;
      this.editForm.isShow = String(this.editForm.isShow);
      this.editForm.isShowNavigation= String(this.editForm.isShowNavigation);
      this.editForm.isShowMina=String(this.editForm.isShowMina);
      this.editId = id;
      this.editShow = true;
    },
    editCancel(){
      this.$refs.edit.resetFields();
      this.editForm = {};
    },
    //修改
    async editOk() {
      this.$refs.edit.validate(async (valid) => {
        if (valid) {
          const data = {
            title: this.editForm.title,
            code: this.editForm.code,
            isShow: this.editForm.isShow,
            showImg: this.editForm.showImg,
            isShowNavigation:this.editForm.isShowNavigation,
            isShowMina:this.editForm.isShowMina,
            platform:this.platform
          };
          const edit = await putProgram(this.editId, data);
          if (edit.code === 0) {
            //刷新列表
            await this.getProgramList(this.pagination.current);
            this.$message.success("修改成功");
            //清空输入框
            this.editCancel();
            //关闭对话框
            this.editShow = false;
          }
        } else {
          this.$message.error("输入有空~");
          return false;
        }
      });
    },
    async  switchIsShowMina(id,isShowMina,item){
    const data = {
            title: item.title,
            code: item.code,
            isShow:item.isShow,
            showImg: item.showImg,
            isShowNavigation:item.isShowNavigation,
            isShowMina:isShowMina,
          };
          const edit = await putProgram(id, data);
          if (edit.code === 0) {
            //刷新列表
            await this.getProgramList(this.pagination.current);
          }
    },
    async switchIsShow(id,isShow,item){
         const data = {
            title: item.title,
            code: item.code,
            isShow:isShow,
            showImg: item.showImg,
            isShowNavigation:item.isShowNavigation,
            isShowMina:this.addForm.isShowMina,
          };
          const edit = await putProgram(id, data);
          if (edit.code === 0) {
            //刷新列表
            await this.getProgramList(this.pagination.current);
          }
    },
    async switchIsShowNavigation(id,isShowNavigation,item){
            const data = {
            title: item.title,
            code: item.code,
            isShow:item.isShow,
            showImg: item.showImg,
            isShowNavigation:isShowNavigation,
            isShowMina:this.addForm.isShowMina,
          };
          const edit = await putProgram(id, data);
          if (edit.code === 0) {
            //刷新列表
            await this.getProgramList(this.pagination.current);
          }
    },
    //删除栏目
    async delBtn(id) {
      const Info = await delProgram(id);
      if (Info.code === 0) {
        await this.getProgramList(this.pagination.current);
        this.$message.success("删除成功");
      } else {
        this.$message.warn("删除失败");
      }
    },
    cancel() {
      this.$message.warning("取消删除");
    },
    //上传封面图
    async upload(e) {
      const upload = await update_New("other", e.target.files[0]);
      if (upload.code === 0) {
        // this.addForm.showImg = upload.data.url;
        this.$set(this.addForm, "showImg", upload.data.url);
        // console.log(this.addForm.showImg);
        this.$message.success("上传成功");

        document.getElementById("uploadImg").value = null;
      } else {
        message.error(upload.message);
      }
    },
    async uploadEdit(e) {
      const upload = await update_New("other", e.target.files[0]);
      if (upload.code === 0) {
        // this.addForm.showImg = upload.data.url;
        this.$set(this.editForm, "showImg", upload.data.url);
        // console.log(this.addForm.showImg);
        this.$message.success("上传成功");

        document.getElementById("uploadImg").value = null;
      } else {
        message.error(upload.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.programManagement {
  //background-color: rgba(240, 242, 245, 1);
  .search_Info {
    border-radius: 3px;
    background-color: white;
    height: 80px;
    width: 100%;
    margin: 0 auto;
    line-height: 70px;
    display: flex;
    padding: 0 15px 0 15px;
    border-bottom: 10px solid rgba(240, 242, 245, 1);
  }
  .table_Info {
    height: 100%;
    width: 100%;
    margin: 10px 0 0 0;
    padding: 15px;
    background-color: white;
  }
}

.uploadImg {
  border: #dddddd 2px dashed;
  width: 100px;
  height: 100px;
  background-image: url("../../../assets/add.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  cursor: pointer;
  margin: 0 auto 5px;
  //float: left;
}

.upload1 {
  position: relative;
  border: 1px #dddddd dashed;
  width: 325px;
  height: 90px;
}
</style>
